// src/App.jsx
import React from 'react';
import AppRoutes from './routes/AppRoutes';
import AuthProvider from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { AWSProvider } from './contexts/AWSContext';
import { CacheProvider } from './contexts/CacheContext';

const App = () => {
  return (
    <LanguageProvider>
      <AWSProvider>
        <AuthProvider>
          <CacheProvider>
            <AppRoutes />
          </CacheProvider>
        </AuthProvider>
      </AWSProvider>
    </LanguageProvider>
  );
};

export default App;
